import { render, staticRenderFns } from "./ExamForm.vue?vue&type=template&id=33bdb3af&"
import script from "./ExamForm.vue?vue&type=script&lang=js&"
export * from "./ExamForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports